(ns manage.product-ocp.hooks
  (:require ["moment/min/moment-with-locales$default" :as moment]
            [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [common.form :as form]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.product :as product.q]
            [common.resource.query.product-store :as product-store.q]
            [malli.core :as m]
            [malli.transform :as mt]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(def sku-schema
  [:string {:min 1 :max 70
            :error/fn (fn [{:keys [value]} _]
                        (cond
                          (str/blank? value) "The field should not be empty"
                          (> (count value) 70) "Name can not be longer than 70 characters."
                          :else nil))}])

(defn field-value-schema [field-type]
  (case field-type
    "number" [number? {:error/message "The field should be a number"}]
    "url" [:and
           [:string {:error/message "The field should be a valid URL"}]
           [:fn {:error/message "The field should be a valid URL"}
            (fn [value]
              (re-matches #"^(https?:)?//.+\..+" value))]]
    "image-url" [:and
                 [:string {:error/message "The field should be a valid URL"}]
                 [:fn {:error/message "The field should be a valid URL"}
                  (fn [value]
                    (re-matches #"^(https?:)?//.+\..+" value))]]

    "date-time" [:any {:decode/json {:enter #(moment %)}}]

    "boolean"
    :boolean

    ("keyword" "text" "blob")
    [:string]))

(defn create-fields-schema [product-store-fields]
  (if (empty? product-store-fields)
    [:map-of :keyword :any]
    (into [:map]
          (for [{:keys [name type]} product-store-fields]
            [(keyword name) {:optional true} [:maybe (field-value-schema type)]]))))

(defn create-form-schema [product-store-fields]
  [:map
   [:sku sku-schema]
   [:fields (create-fields-schema product-store-fields)]])

(defhook use-product-form [product]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])

        {product-store :data :keys [isLoading]}
        (use-query (product-store.q/product-store-query
                    {:advertiser-id advertiser-id}))

        product-store-fields (or (:fields product-store) [])

        ;; Mutations
        {create-product :mutate}
        (use-mutation (product.q/create-product-mutation
                       {:advertiser-id advertiser-id}))

        {update-product :mutate}
        (use-mutation (product.q/update-product-mutation
                       {:advertiser-id advertiser-id}))

        {delete-product :mutate}
        (use-mutation (product.q/delete-product-mutation
                       {:advertiser-id advertiser-id
                        :product-id (:id product)}))

        schema (uix/use-memo (fn []
                               (create-form-schema product-store-fields))
                             [product-store-fields])
        form-resolver (form/use-malli-resolver schema)

        default-values (uix/use-memo
                        (fn []
                          (m/decode schema
                                    {:sku (:sku product "")
                                     :fields (:fields product {})}
                                    mt/json-transformer))
                        [product schema])


        {:keys [handleSubmit setError] :as form-control}
        (form/use-form #js {:mode "onBlur"
                            :defaultValues (->js default-values)
                            :resolver form-resolver})

        mode (if product :edit :create)

        on-submit (uix/use-callback
                   (fn [values]
                     (if (= mode :edit)
                       (update-product values
                                       #js {:onSuccess #(rf/dispatch [:ocp/close])})
                       (create-product values
                                       #js {:onSuccess #(rf/dispatch [:ocp/close])
                                            :onError (fn [error]
                                                       (let [data (->clj (:data error) :recursive true)
                                                             sku-error (get-in data [:error  :spec 0 :sku 0])]
                                                         (when (= sku-error "duplicate")
                                                           (setError "sku"
                                                                     #js {:type "manual"
                                                                          :message "Product with SKU already exists"}))))})))
                   [mode create-product update-product setError])

        on-delete (uix/use-callback
                   (fn []
                     (delete-product nil
                                     #js {:onSuccess #(rf/dispatch [:ocp/close])}))
                   [delete-product])]

    {:form-control form-control
     :on-submit (handleSubmit on-submit)
     :on-delete on-delete
     :product-store-fields product-store-fields
     :mode mode
     :loading isLoading}))
